import React, { useState, useEffect } from "react";
import Select from "@atlaskit/select";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { PaginationType } from "../../../../../../../common/interfaces/flow/action/WebRequestAction";
import { newDefaultPagination } from "./utils/paginationUtil";

const PaginationTypeList = ({ action, paginationType, onPaginationTypeChange }) => {
  const [paginationOptions, setPaginationOptions] = useState([
    { label: "Auto increment", value: PaginationType.AUTO_INCREMENT },
    { label: "Response Based", value: PaginationType.RESPONSE_BASED },
    { label: "Custom Script", value: PaginationType.CUSTOM },
  ]);
  const [value, setValue] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (paginationType) {
      const option = paginationOptions.find((o) => o.value === paginationType);
      setValue(option || null);
    } else {
      setValue(null);
    }
  }, [paginationType, paginationOptions]);

  const changeValue = (item) => {
    setValue(item);
    const selectedType = item?.value;
    if (!selectedType) {
      if (onPaginationTypeChange) {
        onPaginationTypeChange(null);
      }
      return;
    }
    const enabled = action?.pagination?.enabled ?? false;
    const breakJsonPath = action?.pagination?.breakJsonPath ?? "$";
    const variableName = action?.pagination?.variable?.name;
    action.pagination = newDefaultPagination(variableName, selectedType);
    action.pagination.enabled = enabled;
    action.pagination.breakJsonPath = breakJsonPath;
    dispatch(setEditorSaved(false));
    if (onPaginationTypeChange) {
      onPaginationTypeChange(selectedType);
    }
  };

  return (
    <Select
      inputId="pagination_select"
      className="ihub-pagination_select"
      options={paginationOptions}
      value={value}
      placeholder="Select type of pagination"
      onChange={changeValue}
      spacing="compact"
    />
  );
};

export default PaginationTypeList;
